/**
 * DEMO DISPLAY DATA — Sweet Futures client demo (2026-07-22).
 *
 * Static, hand-authored block account + SMA (sub-managed account) data for
 * the read-only /accounts view. There is no backend account/SMA model yet —
 * this is entirely a frontend fixture with plausible-but-obviously-fake
 * numbers. No API calls, no store. Delete this file (and the /accounts
 * route) once a real block-account API exists.
 */

export interface DemoSma {
  id: string;
  name: string;
  balance: number;
  strategyCount: number;
  mtdReturnPercent: number;
}

export interface DemoBlockAccount {
  name: string;
  accountNumber: string;
  balance: number;
  smas: DemoSma[];
}

export const DEMO_BLOCK_ACCOUNT: DemoBlockAccount = {
  name: "Marex Block — Sweet Futures",
  accountNumber: "MRX-2201-DEMO",
  balance: 4_200_000,
  smas: [
    {
      id: "sma-family-office-a",
      name: "Family Office A",
      balance: 1_650_000,
      strategyCount: 4,
      mtdReturnPercent: 2.35,
    },
    {
      id: "sma-family-office-b",
      name: "Family Office B",
      balance: 1_400_000,
      strategyCount: 3,
      mtdReturnPercent: -0.82,
    },
    {
      id: "sma-family-office-c",
      name: "Family Office C",
      balance: 1_150_000,
      strategyCount: 5,
      mtdReturnPercent: 1.14,
    },
  ],
};
